import React, { useCallback } from 'react';

import { FiInfo } from 'react-icons/fi';
import { FaCheck } from 'react-icons/fa';
import TooltipInfo from './TooltipInfo';

import { useNewRefuel } from '../../../../hooks/useNewRefuel';

import {
  Container,
  InputWrapper,
  InputSelect,
  BaseInfoWrapper,
  InfosDetailWrapper,
  InfoDetailWrapper,
  TitleInfoWrapper,
  BaseName,
  BaseAddress,
  TitleDetail,
  DetailInfo,
  Divisor,
} from './styles';

type BaseItemProps = {
  baseName: string;
  nickName: string;
  address: string;
  isSelected: boolean;
  routeDays?: string;
  supplyWay?: string;
};

const BaseItem: React.FC<BaseItemProps> = ({
  nickName,
  baseName,
  address,
  isSelected,
  routeDays = '',
  supplyWay = '',
}) => {
  const { addSelectedBase, removeSelectedBase } = useNewRefuel();

  const handleSelectBase = useCallback(() => {
    if (isSelected) {
      return removeSelectedBase(baseName);
    }
    return addSelectedBase(baseName);
  }, [baseName, isSelected, addSelectedBase, removeSelectedBase]);

  return (
    <Container isSelected={isSelected}>
      <InputWrapper>
        <InputSelect isSelected={isSelected} onClick={handleSelectBase}>
          {isSelected && <FaCheck color="#ffff" />}
        </InputSelect>
      </InputWrapper>
      <BaseInfoWrapper>
        <BaseName isSelected={isSelected}>{nickName}</BaseName>
        <BaseAddress>{address}</BaseAddress>
      </BaseInfoWrapper>
      <Divisor />
      <InfosDetailWrapper>
        <InfoDetailWrapper>
          <TitleInfoWrapper>
            <TitleDetail isSelected={isSelected}>
              Forma de abastecimento
            </TitleDetail>
            <TooltipInfo
              routeType={false}
              isAutomatic={supplyWay === 'Automático'}
              icon={<FiInfo color="#0B29FB" />}
              textTooltip={
                supplyWay === 'Automático'
                  ? 'Com o abastecimento automático da Ultragaz, seu consumo é monitorado de perto, garantindo que você nunca fique sem gás. Já na opção de abastecimento via pedido, você precisa solicitar o reabastecimento manualmente sempre que o nível do tanque estiver baixo.'
                  : 'A gestão do seu abastecimento ainda não está conosco, por isso você precisará realizar a solicitação de abastecimento de acordo com a sua necessidade. Nesse caso é importante se atentar aos dias de rota disponíveis na sua região para que possamos realizar a entrega de forma mais assertiva. Para garantir mais comodidade ao seu dia a dia converse com a Ully, a nossa assistente virtual, e altere o seu modelo de abastecimento para o tipo “Automático”.'
              }
            />
          </TitleInfoWrapper>
          <DetailInfo isSelected={isSelected}>{supplyWay}</DetailInfo>
        </InfoDetailWrapper>
        <InfoDetailWrapper>
          <TitleInfoWrapper>
            <TitleDetail isSelected={isSelected}>Dias de rota</TitleDetail>
            <TooltipInfo
              isAutomatic={false}
              routeType
              icon={<FiInfo color="#0B29FB" />}
              textTooltip="Os dias de rota seguirão os dias da semana definidos previamente, e o tempo de viagem poderá variar entre 1 ou mais dias, dependendo do tipo de dia escolhido para a rota"
            />
          </TitleInfoWrapper>
          <DetailInfo isSelected={isSelected}>{routeDays}</DetailInfo>
        </InfoDetailWrapper>
      </InfosDetailWrapper>
    </Container>
  );
};

BaseItem.defaultProps = {
  routeDays: '',
  supplyWay: '',
};

export default BaseItem;
